export default {
  start() {
    // Note: auth-token helpers must be available before Session init (via auth store).
    // TODO: deprecate this whole module in favor of auth stores
    window.App.stores.requestStore("auth")

    window.App.on("session:unauthenticated", function () {
      window.userData = null
      if (window.bootstrappedData != null) {
        window.bootstrappedData.user = null
      }
      return delete window.userData
    })
  }
}
